import Store from '../store';
import { computeRowlenByContent,computeColWidthByContent } from './getRowlen';
import luckysheetConfigsetting from '../controllers/luckysheetConfigsetting';

export default function rhchInit(rowheight, colwidth) {
    zoomSetting();//Zoom sheet on first load
    //行高
    if(rowheight != null){
        Store.visibledatarow = [];
        Store.rh_height = 0;

        for (let r = 0; r < rowheight; r++) {
            let rowlen = Store.defaultrowlen;

            if (Store.config["rowlen"] != null && Store.config["rowlen"][r] != null) {
                rowlen = Store.config["rowlen"][r];
            }

            if (Store.config["rowhidden"] != null && Store.config["rowhidden"][r] != null) {
                Store.visibledatarow.push(Store.rh_height);
                continue;
            }

            // 自动行高计算
            if (rowlen === 'auto') {
                rowlen = computeRowlenByContent(Store.flowdata, r);
            }
            Store.rh_height += Math.round((rowlen + 1) * Store.zoomRatio);

            Store.visibledatarow.push(Store.rh_height); //行的临时长度分布
        }

        // 如果增加行和回到顶部按钮隐藏，则减少底部空白区域，但是预留足够空间给单元格下拉按钮
        if (!luckysheetConfigsetting.enableAddRow && !luckysheetConfigsetting.enableAddBackTop) {
            Store.rh_height += 29;
        } else {
            Store.rh_height += 80;  //最底部增加空白
        }

    }

    //列宽
    if(colwidth != null){
        Store.visibledatacolumn = [];
        Store.ch_width = 0;

        let maxColumnlen = 120;

        // 是否存在百分比列宽
        let hasPercentWidth = false;
        for (let c = 0; c < colwidth; c++) {
            if (Store.config["columnlen"] != null && Store.config["columnlen"][c] != null) {
                const val = Store.config["columnlen"][c];
                if (typeof val === 'string' && /%$/.test(val)) {
                    hasPercentWidth = true;
                    break;
                }
            }
        }

        // 预计算可用宽度（内容区宽度）
        let availableWidth = Store.cellmainWidth != null && Store.cellmainWidth > 0
            ? Store.cellmainWidth
            : $("#" + Store.container).width() - Store.rowHeaderWidth;

        if(['wire'].includes(luckysheetConfigsetting.activePanel) && luckysheetConfigsetting.verityShow && availableWidth < 1920) {
            availableWidth = 1960; //线表且展示校核结果时，保证有足够宽度展示内容
        } else if(availableWidth < 1200) {
            availableWidth = 1200; //最小宽度限制，保证基础使用体验
        }
        // 收集百分比总和与固定像素总和
        let percentSpecs = {};
        let totalPercent = 0;
        let totalFixedPx = 0;
        // 隐藏列 宽度计算需要减隐藏列，及border宽度
        let { colhidden = {} } = luckysheet.getconfig()
        let colLength = 0
        if (hasPercentWidth) {
            for (let c = 0; c < colwidth; c++) {
                if(colhidden[c] != 0) {
                    colLength += 1
                    let spec = Store.config["columnlen"] && Store.config["columnlen"][c];
                    if (typeof spec === 'string' && /%$/.test(spec)) {
                        let p = parseFloat(spec);
                        if (isNaN(p)) p = 0;
                        percentSpecs[c] = p;
                        totalPercent += p;
                    } else if (spec === 'auto') {
                        // auto 先不计入固定像素，稍后按内容计算
                    } else if (spec != null) {
                        totalFixedPx += Number(spec) || 0;
                    }
                }
            }
        }

        for (let c = 0; c < colwidth; c++) {
            let firstcolumnlen = Store.defaultcollen;

            if (Store.config["columnlen"] != null && Store.config["columnlen"][c] != null) {
                firstcolumnlen = Store.config["columnlen"][c];
            }
            else {
                if (Store.flowdata[0] != null && Store.flowdata[0][c] != null) {
                    if (firstcolumnlen > 300) {
                        firstcolumnlen = 300;
                    }
                    else if (firstcolumnlen < Store.defaultcollen) {
                        firstcolumnlen = Store.defaultcollen;
                    }

                    if (firstcolumnlen != Store.defaultcollen) {
                        if (Store.config["columnlen"] == null) {
                            Store.config["columnlen"] = {};
                        }

                        Store.config["columnlen"][c] = firstcolumnlen;
                    }
                }
            }

            if(Store.config["colhidden"] != null && Store.config["colhidden"][c] != null){
                Store.visibledatacolumn.push(Store.ch_width);
                continue;
            }

            // 自动行高计算
            if (firstcolumnlen === 'auto') {
                firstcolumnlen = computeColWidthByContent(Store.flowdata, c, rowheight);
            }
            // 百分比列宽计算
            if (typeof firstcolumnlen === 'string' && /%$/.test(firstcolumnlen)) {
                // 如果存在多个百分比，按比例分配剩余宽度（去除固定像素和滚动条等)
                let percent = parseFloat(firstcolumnlen);
                if (isNaN(percent)) percent = 0;
                let baseWidth = availableWidth;
                if (hasPercentWidth) {
                    // 从可用宽度中减去固定像素列，剩余部分按百分比分配
                    // colLength + 1 边框
                    // 右侧滚动条宽度
                    baseWidth = Math.max(0, availableWidth - totalFixedPx - (colLength + 1) - 12);
                    // 如果百分比总和不为100，以总和作为基准归一化
                    if (totalPercent > 0) {
                        firstcolumnlen = (baseWidth * (percent / totalPercent));
                    } else {
                        firstcolumnlen = (baseWidth * (percent / 100));
                    }
                } else {
                    firstcolumnlen = availableWidth * (percent / 100);
                }
            }

            // 控制列的最小宽度，如果小于120就按照120展示
            let titleObj = luckysheetConfigsetting.customColumnTitles[c];
            const minColumnWidth = 80;
            const minColNumberWidth = 50;
            if(/%$/.test(titleObj.width)
                &&(
                    ['equipment','crossing','wireline', 'cable'].includes(luckysheetConfigsetting.activePanel)
                )
            ) {
                if(titleObj && (titleObj.optionContentType == 'number' || titleObj.optionContentType == 'int')){
                    if(firstcolumnlen < minColNumberWidth) {
                        firstcolumnlen = minColNumberWidth;
                    }
                } else if (firstcolumnlen < minColumnWidth) {
                    firstcolumnlen = minColumnWidth;
                }
            }
            
            Store.ch_width += Math.round((parseFloat(firstcolumnlen) + 1)*Store.zoomRatio);
            Store.visibledatacolumn.push(Store.ch_width);//列的临时长度分布

            // if(maxColumnlen < firstcolumnlen + 1){
            //     maxColumnlen = firstcolumnlen + 1;
            // }
        }

        // Store.ch_width += 120;
        // Store.ch_width += maxColumnlen;
        Store.ch_width += 12; //预留滚动条宽度
    }
}


export function zoomSetting(){
    //zoom
    Store.rowHeaderWidth = luckysheetConfigsetting.rowHeaderWidth * Store.zoomRatio;
    Store.columnHeaderHeight = luckysheetConfigsetting.columnHeaderHeight *Store.zoomRatio;
    // if(Store.showCheckbox) {
    //    $("#luckysheet-rows-h").css({
    //         widht: Store.rowHeaderWidth - Store.checkboxWidth - 2.5,
    //         left: Store.checkboxWidth
    //     }); 
    // } else {
    //     $("#luckysheet-rows-h").width((Store.rowHeaderWidth-1.5));
    // }
    $("#luckysheet-rows-h").width((Store.rowHeaderWidth-1.5));
    // if(Store.showCheckbox) {
    //    $("#luckysheet-rows-h-hover, #luckysheet-rows-h-selected, #luckysheet-rows-change-size").css({
    //         widht: Store.rowHeaderWidth - Store.checkboxWidth - 2.5,
    //         left: Store.checkboxWidth
    //     }); 
    // }
    $("#luckysheet-cols-h-c").height((Store.columnHeaderHeight-1.5));
    $("#luckysheet-left-top").css({width:Store.rowHeaderWidth-1.5, height:Store.columnHeaderHeight-1.5});
}
